// removed by extract-text-webpack-plugin
module.exports = {"trustedContactInfo":"src-components-TrustedContactInfo-___index__trustedContactInfo___2zOHh","trustedContactInfoMessage":"src-components-TrustedContactInfo-___index__trustedContactInfoMessage___3aRpm","trustedContactInfoArrow":"src-components-TrustedContactInfo-___index__trustedContactInfoArrow___1DBnp","trustedContactInfoCentered":"src-components-TrustedContactInfo-___index__trustedContactInfoCentered___2_lRY","tcDivider":"src-components-TrustedContactInfo-___index__tcDivider___26O1f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TrustedContactInfo/index.css
// module id = 963
// module chunks = 3